export enum DateFormats {
    Endpoint = 'YYYY-MM-DD',
    Screen = 'MM/DD/YYYY',
    Route = 'YYYYMMDD'
}
